module.exports = __webpack_public_path__ + "img/SoftwareCopyright_8.aee00c75.png";